function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import { componentStyles } from "./simpo-component.scss";
const MAIN_SCRIPT = `!function(){var r=window.actionbar=window.actionbar||[];if(!r.initialize&&!r.invoked){r.invoked=!0,r.methods=["configure","identify","reset","ready","debug","off","on"],r.generator=function(t){return function(){var e=Array.prototype.slice.call(arguments);return e.unshift(t),r.push(e),r}};for(var e=0;e<r.methods.length;e++){var t=r.methods[e];r[t]=r.generator(t)}r.load=function(e){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="https://cdn.simpo.io/actionbar.js",r.ucid=e;var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)},r.SNIPPET_VERSION="2.0.0"}}();;
actionbar.load("fnvrfechqj2ppxqjue0ketduibbin46thb9wcatpbz8");`;
const STARTUP_SCRIPT = `actionbar.configure({
  bar: {
      embedMode: 'inline',
      container: '.action-bar-wrapper',
      width: '100%'
  },
  widget: {
      show: false
  }
});
`;
const HIDE_SCRIPT = `actionbar.on('ready', function() {
  actionbar.jQuery("form[role='search']").remove();
});`;
class SimpoComponent extends PureComponent {
    componentDidMount() {
        this.runScript(MAIN_SCRIPT);
        this.runScript(STARTUP_SCRIPT);
        this.runScript(HIDE_SCRIPT);
    }
    runScript(script) {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.innerHTML = script;
        this.instance.appendChild(s);
    }
    render() {
        const { backgroundColor, paragraph } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                backgroundColor
            },
            ref: (el)=>this.instance = el,
            className: `jsx-${componentStyles.__hash}` + " " + "simpo-component-wrapper",
            children: [
                /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread({}, paragraph)),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "action-bar-wrapper"
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { SimpoComponent as default };
